export const myLogin = {
    email: 'mailfortest118@gmail.com',
    password: 'passwordtest'
}
